import styled from 'styled-components';

export const ContainerViewExamMobile = styled.div<{ colorTextInfo: string }>`
  color: ${({ colorTextInfo }) => colorTextInfo};
  display: flex;
  flex-direction: column;
`;

export const CourseName = styled.b`
  font-weight: 900;
  font-size: 16px;
`;

export const ExamInfo = styled.div<{ marginTop?: number }>`
  margin-top: ${({ marginTop }) => marginTop ?? 0}px;
`;

export const ExternalLinkWrapper = styled.div`
  margin-top: 12px;
`;
